/**
 * Step 1: Select Action (Add or Remove)
 *
 * Migrated from: lego/page/etmf/overview/update-study/Step1.jsx
 */

import React from 'react'
import { useServiceContext } from '../../../../root'
import { useDialogContext } from './context/useDialogContext'
import type { FormValues } from './context/DialogContext'

interface Step1Props {
  values: FormValues
  setFieldValue: (field: string, value: any) => void
}

export default function Step1({ values, setFieldValue }: Step1Props) {
  const context = useServiceContext()
  const dialogData = useDialogContext()
  const { translate } = context.service.filter

  return (
    <div className="step">
      <div className="form-group">
        <label className="control-label">{translate('ETMF_SELECT_ACTION')}</label>

        <div className="radio classic mb10 w100p">
          <input
            style={{ margin: '4px 0 0 0' }}
            type="radio"
            name="updateAction"
            id="add-action"
            value={dialogData.actionOptions.add}
            checked={values.action === dialogData.actionOptions.add}
            onChange={(event) => {
              setFieldValue('action', event.target.value)
            }}
          />
          <label htmlFor="add-action">{translate('ETMF_UPDATE_STUDY_STRUCTURE_ADD')}</label>
        </div>

        <div className="radio classic mb10 w100p">
          <input
            style={{ margin: '4px 0 0 0' }}
            type="radio"
            name="updateAction"
            id="remove-action"
            value={dialogData.actionOptions.remove}
            checked={values.action === dialogData.actionOptions.remove}
            onChange={(event) => {
              setFieldValue('action', event.target.value)
            }}
          />
          <label htmlFor="remove-action">{translate('ETMF_UPDATE_STUDY_STRUCTURE_REMOVE')}</label>
        </div>
      </div>
    </div>
  )
}
